import React from "react";
import InputText from "../ReusableComponents/InputText";
import DropDown from "../ReusableComponents/DropDown";

const GradePopup = ({ data, data1 }) => {
  return (
    <div className="mx-auto p-8 maxw-7xl">
      {/* <div className="w-full md:w-3/4 space-y-6"> */}
        <div className="grid grid-cols-3 gap-4">
          <DropDown
            type={"select-one"}
            classStar="text-red-500"
            title={"Grade"}
            name={"grade"}
            selectedOption={data.Grade ?? ""}
            options={Array.isArray(data1) ? data1 : []}
            disabled="disabled"
          />
        </div>
        <div>
          <div className="font-semibold  pb-2">Gross Salary</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <InputText
              inputType="number"
              title="Basic Salary"
              name="basicSalary"
              rows="4"
              disabled="disabled"
              content={data.BasicSalary}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="DA"
              name="da"
              rows="4"
              disabled="disabled"
              content={data.DA}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="HRA"
              name="hra"
              rows="4"
              disabled="disabled"
              content={data.HRA}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Conveyance"
              name="Conveyance"
              rows="4"
              disabled="disabled"
              content={data.Conveyance}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Medical"
              name="medical"
              rows="4"
              disabled="disabled"
              content={data.Medical}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Performance"
              name="performance"
              rows="4"
              disabled="disabled"
              content={data.Performance}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Others"
              name="others"
              rows="4"
              disabled="disabled"
              content={data.Others}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Total"
              name="grossSalaryTotal"
              rows="4"
              disabled="disabled"
              content={data.GrossSalaryTotal}
              classStar="text-red-500"
            />
          </div>
        </div>
        <div>
          <div className="font-semibold  pb-2">Deductions</div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            <InputText
              inputType="number"
              title="PF"
              name="pf"
              rows="4"
              disabled="disabled"
              content={data.PF}
              classStar="text-red-500"
              icon={<span>%</span>}
            />
            <InputText
              inputType="number"
              title="ESI"
              name="esi"
              rows="4"
              disabled="disabled"
              content={data.ESI}
              classStar="text-red-500"
              icon={<span>%</span>}
            />
            <InputText
              inputType="number"
              title="Insurance"
              name="insurance"
              rows="4"
              disabled="disabled"
              content={data.Insurance}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Loan"
              name="loan"
              rows="4"
              disabled="disabled"
              content={data.Loan}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Tax"
              name="tax"
              rows="4"
              disabled="disabled"
              content={data.Tax}
              classStar="text-red-500"
            />
            <InputText
              inputType="number"
              title="Total"
              name="deductionTotal"
              rows="4"
              disabled="disabled"
              content={data.DeductionsTotal}
              classStar="text-red-500"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <InputText
            inputType="number"
            title="Net Total (Gross salary Total - Deductions Total)"
            name="netTotal"
            rows="4"
            disabled="disabled"
            content={data.NetTotal}
            classStar="text-red-500"
          />
        </div>
      {/* </div> */}
    </div>
  );
};
export default GradePopup;
